/**
 * @generated SignedSource<<3ae61020cef4fc3dfb263bffd19a9944>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssigneesSectionCopilotRepositoryFragment$data = {
  readonly isArchived: boolean;
  readonly isCopilotAgentEnabled: boolean | null | undefined;
  readonly " $fragmentType": "AssigneesSectionCopilotRepositoryFragment";
};
export type AssigneesSectionCopilotRepositoryFragment$key = {
  readonly " $data"?: AssigneesSectionCopilotRepositoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssigneesSectionCopilotRepositoryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssigneesSectionCopilotRepositoryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCopilotAgentEnabled",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "d0d5039c0af037561a9f4ee503f04833";

export default node;
